import Analytics from '@withlocals/withlocals-analytics';
import RoundedButton from 'components/RoundedButton';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const CSS = require('./Notfound.less');

class NotfoundInternal extends PureComponent<RouteComponentProps> {
  componentDidMount() {
    Analytics.track('404', window.location.href, window.document.referrer);
    console.error(
      `404 rendered (pathname: ${window.location.pathname}, search: ${window.location.search}, referrer: ${window.document.referrer}, href: ${window.location.href})`,
    );
    window.scrollTo(0, 0);
  }
  goHome = () => {
    this.props.history.push('/');
  };
  render() {
    return (
      <div className={CSS.NotFoundContainer}>
        <Helmet>
          <meta name="render:status_code" content="404" />
        </Helmet>
        <div className={CSS.NotFoundHeader}>
          <h1 className={CSS.NotFoundTitle}>404 Page not found</h1>
        </div>
        <div className={CSS.NotFoundSubtitleContainer}>
          <RoundedButton
            onClick={this.goHome}
            className={CSS.NotFoundSubtitle}
            inverted
          >
            Find your destination
          </RoundedButton>
        </div>
      </div>
    );
  }
}

export const NotFoundComponent = withRouter(NotfoundInternal);

export default () => {
  return (
    <NavigationableLayout
      component={NotFoundComponent}
      showSearchInNavbar
      transparentNavbar
    />
  );
};
